module.exports = __webpack_public_path__ + "img/3.fd9a0653.png";